module.exports = __webpack_public_path__ + "static/media/Danske_Bank.bab59623.svg";